import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { Page, Text, View, Link } from '@react-pdf/renderer';

import { useTranslation } from 'react-i18next';
import { globalStyles } from '../../styles';
import { styles } from './styles';
import { getImageSrc } from '@utils/fn';
import { SafeImage } from '../../components/SafeImage';
import { truncateText, normalizeText } from '../../../utils';

interface EventLocationPageProps {
  event: PublicEventDetailsResponse;
  header: JSX.Element;
  footer: JSX.Element;
}

const EventLocationPage = ({
  event,
  header,
  footer,
}: EventLocationPageProps) => {
  const { t } = useTranslation();
  const street = event?.location?.marker?.street || event?.address?.street;
  const postalCode =
    event?.location?.marker?.postalCode || event?.address?.postalCode;
  const city = event?.location?.marker?.city || event?.address?.city;
  const country = event?.location?.marker?.country || event?.address?.country;

  const reservationFAQItem = event?.website_content?.faqs?.find(
    faq => faq?.type === 'hotel-reservation'
  );

  return (
    <Page style={{ ...styles.page }}>
      {header}

      <View style={styles.contentWrapper}>
        <Text
          style={{
            ...styles.title,
            color: event?.design?.themeColor,
          }}
        >
          {t('event-location')}
        </Text>

        <View
          style={{
            ...globalStyles.lineBar,
            borderColor: event?.design?.themeColor ?? 'black',
            marginLeft: 0,
            marginBottom: 10,
            width: 89,
          }}
        />

        <View style={styles.locationWrapper}>
          <Text style={styles.icon}>{'\uf3c5'}</Text>
          <Text style={styles.location}>
            {street}, {postalCode} {city}, {t(`countries.${country}`)}
          </Text>
        </View>

        <Text style={styles.description}>
          {truncateText(
            normalizeText(event?.location?.description || ''),
            1500
          )}
        </Text>

        {(event?.location?.images as any)?.image_additional_one && (
          <View>
            <SafeImage
              style={styles.image}
              src={getImageSrc(
                (event?.location?.images as any).image_additional_one
              )}
              debugLabel="event-location-image-1"
            />
          </View>
        )}

        {(event?.location?.images as any)?.image_additional_two &&
          (event?.location?.images as any)?.image_additional_three && (
            <View style={styles.imageRow}>
              <View style={styles.imageLeftWrapper}>
                <SafeImage
                  style={{
                    ...styles.imageLeft,
                  }}
                  src={getImageSrc(
                    (event?.location?.images as any).image_additional_two
                  )}
                  debugLabel="event-location-image-2"
                />
              </View>

              <View style={styles.imageRightWrapper}>
                <SafeImage
                  style={{
                    ...styles.imageRight,
                  }}
                  src={getImageSrc(
                    (event?.location?.images as any).image_additional_three
                  )}
                  debugLabel="event-location-image-3"
                />
              </View>
            </View>
          )}

        <View style={styles.bottomWrapper}>
          <Text style={styles.stayLabel}>
            {t('stay-where-the-event-happens')}
          </Text>

          <View
            style={{
              ...styles.buttonWrapper,
              backgroundColor: event?.design?.themeColor ?? 'black',
            }}
          >
            <Link
              href={reservationFAQItem?.reservation_link || ''}
              style={styles.buttonLink}
            >
              {t('reserve-your-room-with-our-special-event-contingent')}
            </Link>
          </View>
        </View>
      </View>

      {footer}
    </Page>
  );
};

export default EventLocationPage;
